import { gql } from '@apollo/client'

export default gql(`
subscription{
    bucketGroupUpdated{
            id
            name
            type
            key
            isArchived
            bucketGroupItems{
                id
                bucketId
                position
                bucket{
                    displayName
                    name
                    key
                    id
                    isArchived
                }
            }
        } 
    }
`)
